var SoundPool = require('../lib/soundpool');

AFRAME.registerSystem('play-sound', {
  init: function () {
    this.lastSoundPlayed = '';
    this.lastSoundPlayedTime = 0;
    this.pools = {};
  },

  createPool: function (sound, volume) {
    if (this.pools[sound]) { return; }
    this.pools[sound] = new SoundPool(sound, volume);
  },

  playSound: function (sound, volume) {
    if (!this.pools[sound]) {
      this.createPool(sound, volume);
    }
    this.pools[sound].play();

    this.lastSoundPlayed = sound;
    this.lastSoundTime = this.el.time;
  }
});

/**
 * Play sound on event.
 */
AFRAME.registerComponent('play-sound', {
  schema: {
    enabled: {default: true},
    event: {type: 'string'},
    sound: {type: 'string'},
    volume: {type: 'number', default: 1}
  },

  multiple: true,

  init: function () {
    this.el.addEventListener(this.data.event, evt => {
      if (!this.data.enabled) { return; }
      this.system.playSound(this.src, this.data.volume);
    });
  },

  update: function () {
    this.src = this.data.sound;
    if (this.data.sound.startsWith('#')) {
      this.src = document.querySelector(this.data.sound).getAttribute('src');
    }
  }
});
if (module.hot && window.AFRAME) {
  const componentNames = ['play-sound',];

  const shaderNames = [];

  const systemNames = ['play-sound',];

  // Clean up from application when module is unloaded.
  module.hot.dispose(data => {
    let els;
    data.needsReplace = true;

    componentNames.forEach(component => {
      // Unregister.
      delete AFRAME.components[component];
      const els = AFRAME.scenes[0].querySelectorAll(`[${component}]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        els[i].setAttribute(`data-__hot-${component}`,
                            JSON.stringify(els[i].getDOMAttribute(component)));
        // Detach component.
        els[i].removeAttribute(component);
      }
    });

    shaderNames.forEach(shader => {
      // Unregister.
      delete AFRAME.shaders[shader];
      const els = AFRAME.scenes[0].querySelectorAll(`[material]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        if (els[i].getAttribute('material').shader !== shader) { continue; }
        els[i].setAttribute('data-__hot-material', JSON.stringify(
          els[i].getDOMAttribute('material')));
        // Detach material.
        els[i].removeAttribute('material');
      }
    });

    systemNames.forEach(system=> {
      delete AFRAME.systems[system];
      delete AFRAME.scenes[0].systems[system];
    });
  });

  if (module.hot.data && module.hot.data.needsReplace) {
    // Apply component back to entities.
    componentNames.forEach(componentName => {
      const dataAttrName = `data-__hot-${componentName}`;
      const els = document.querySelectorAll(`[${dataAttrName}]`);
      for (let i = 0; i < els.length; i++) {
        els[i].setAttribute(componentName, JSON.parse(els[i].getAttribute(dataAttrName)), true);
        els[i].removeAttribute(dataAttrName);
      }
    });

    // Apply materials back.
    const dataAttrName = 'data-__hot-material';
    const els = document.querySelectorAll(`[${dataAttrName}]`);
    for (let i = 0; i < els.length; i++) {
      els[i].setAttribute('material', JSON.parse(els[i].getAttribute(dataAttrName)), true);
      els[i].removeAttribute(dataAttrName);
    }
  }

  module.hot.accept();
}
